import type { LinkPreview } from '../../schemas/linkPreview.js';
import type { RequestFn } from '../http.js';

/** Link previews ("read-later" unfurl). The client passes a URL it found in a
 *  message; the server fetches + caches it (SSRF-guarded) and returns the card.
 *  Returns a 422 (rejected here as an error) when the URL can't be unfurled. */
export function makeLinkPreviewApi(request: RequestFn) {
  return {
    unfurl: (url: string, channelId?: string) =>
      request<LinkPreview>(
        `/api/unfurl?url=${encodeURIComponent(url)}` +
          (channelId ? `&channelId=${encodeURIComponent(channelId)}` : ''),
      ),
  };
}
